var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlackArrowDown = function SvgBlackArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 7,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1A2550",
    fillOpacity: 0.6,
    d: "M4.306 0H1.812A1.63 1.63 0 0 0 .703 2.657L4.241 6.18a1.516 1.516 0 0 0 2.185 0l3.537-3.522A1.63 1.63 0 0 0 8.855 0z"
  })));
};
export default SvgBlackArrowDown;